import GiftCardPreview from '../gift-card-preview.component';
import type { IPaymentMethodCardPreview } from '../interfaces';

import CreditCardPreview from './credit-card-preview.component';

import './styles.module.scss';

enum PaymentTypes {
  GIFTCARD = 'GIFT_CARD',
  CENCOPAY = 'CENCOPAY'
}

export const PaymentMethodCardPreview = (props: IPaymentMethodCardPreview) => {
  const { paymentMethod, isCencoPayBalance, isCencoPay } = props;

  const isGiftCard = paymentMethod?.type === PaymentTypes.GIFTCARD;

  return (
    <div
      className={`'co-w-full co-relative co-flex co-rounded-8px co-p-16px co-gap-16px ${
        isGiftCard ? 'co-bg-gradient-giftCard' : 'co-bg-gradient-creditCard'
      }  co-shadow-md`}
    >
      {isGiftCard ? (
        <GiftCardPreview paymentMethod={paymentMethod} />
      ) : (
        <CreditCardPreview
          paymentMethod={paymentMethod}
          isCencoPay={isCencoPay}
          isCencoPayBalance={isCencoPayBalance}
        />
      )}
    </div>
  );
};
